module.exports = __webpack_public_path__ + "media/3_8.753e4696.wav";